import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {InfoTreeComponent} from './info-tree.component';
import {MatTreeModule} from '@angular/material/tree';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';

@NgModule({
  declarations: [InfoTreeComponent],
  exports: [
    InfoTreeComponent
  ],
  imports: [
    CommonModule,
    MatTreeModule,
    MatIconModule,
    MatButtonModule
  ]
})

export class InfoTreeModule { }
